import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconDoubleArrowButton = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#FFCC56"
      d="M6.21 5.625c.212.21.212.563 0 .773l-4.124 4.313c-.211.234-.563.234-.797.023a.56.56 0 0 1-.023-.796L5.016 6l-3.75-3.914a.637.637 0 0 1-.141-.398c0-.141.047-.282.164-.399.234-.21.586-.21.797.024L6.21 5.625Zm4.5 0a.552.552 0 0 1 0 .773l-4.124 4.313c-.211.234-.563.234-.797.023a.56.56 0 0 1-.023-.796L9.516 6l-3.75-3.914a.637.637 0 0 1-.141-.398c0-.141.047-.282.164-.399.234-.21.586-.21.797.024l4.125 4.312Z"
    />
  </svg>
));
export default SvgIconDoubleArrowButton;
